
import data from '@/data/permissions.json'

export function getPermissions(user) {
    if (user.roles && user.roles.length > 0) {
        let permissions = []

        for (let key in data) {
            if (user.roles.indexOf(key) != -1) {
                permissions = permissions.concat(data[key])
            }
        }
        return permissions
    }

    return []
}


// WEBPACK FOOTER //
// ./src/api/permission.js